mutation DeleteLinks($ids: [ID!]!) {
  deleteLinks(ids: $ids) {
    id
  }
}
